export const defaultUser = () => ({
    id: '',
    customer_name: '',
    customer_cpf: '',
    customer_email: '',
    customer_phone: '',
    customer_mobile: '',
    product_name: '',
    idle_color: '',
})


export const defaultLoader = () => ({
    body: false,
    overlay: false,
    overlayLoading: true,
    overlaySucess: true,
})

export const defaultActions = () => [
    {
        id: 1,
        label: 'Registrar atendimento',
        action: 'modal-open-sales-deals-select-create-historical',
        gtm: {
            event: 'fac_button_click',
            category: 'vuejs-funil-vendas',
            action: 'click',
            label: 'Registrar atendimento - Contatar o Cliente'
        }
    },
    {
        id: 2,
        label: 'Criar uma tarefa',
        action: 'modal-open-global--create-task',
        gtm: {
            event: 'fac_button_click',
            category: 'vuejs-funil-vendas',
            action: 'click',
            label: 'Criar Uma Tarefa - Contatar o Cliente'
        }
    },
    {
        id: 3,
        label: 'Solicitar reserva de unidade',
        action: 'modal-open-global--request-reserve',
        gtm: {
            event: 'fac_button_click',
            category: 'vuejs-funil-vendas',
            action: 'click',
            label: 'Solicitar Reserva - Contatar o Cliente'
        }
    },
    {
        id: 4,
        label: 'Alterar etapa e status',
        action: 'modal-open-sales-deals-select-stage-status',
        gtm: {
            event: 'fac_button_click',
            category: 'vuejs-funil-vendas',
            action: 'click',
            label: 'Alterar Etapa e Status - Contatar o Cliente'
        }
    },
]